// ════════════════════════════════════════════════════════════════════════
//  Schuladmin einladen
//
//  Das erste Konto einer Schule. Danach lädt die Schule ihre Lehrkräfte selbst
//  ein - in ihrer eigenen Verwaltung, ohne uns.
// ════════════════════════════════════════════════════════════════════════

import { useState } from "react";
import { useSession } from "@otto/plattform";
import { useInviteSchoolAdmin } from "../hooks/useInviteSchoolAdmin.js";
import { inviteErrorText } from "../lib/inviteErrors.js";
import shell from "../../../shared/components/shell.module.css";
import styles from "./schools.module.css";

export function InviteSchoolAdmin({
  schoolId,
  schoolName,
}: {
  schoolId: string;
  schoolName: string;
}) {
  const { client } = useSession();
  const invite = useInviteSchoolAdmin(client);
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");

  return (
    <div className={`${shell.card} ${shell.spaced}`}>
      <h2 className={shell.title} style={{ fontSize: "1.15rem" }}>
        Schuladmin einladen
      </h2>
      <p className={shell.subtitle}>
        Das erste Konto für {schoolName}. Die eingeladene Person erhält eine E-Mail mit
        Anmeldelink und legt danach Lehrkräfte und Klassen selbst an – ohne uns.
      </p>

      {invite.isSuccess && (
        <div className={`${shell.notice} ${shell.noticeGood}`}>Einladung verschickt.</div>
      )}
      {invite.isError && (
        <div className={`${shell.notice} ${shell.noticeError}`}>
          {inviteErrorText(
            invite.error.message,
            (invite.error as { status?: number }).status,
          )}
        </div>
      )}

      <form
        onSubmit={(event) => {
          event.preventDefault();
          invite.mutate(
            { schoolId, email: email.trim(), name: name.trim() },
            {
              onSuccess: () => {
                setEmail("");
                setName("");
              },
            },
          );
        }}
      >
        <div className={styles.columns}>
          <div>
            <label htmlFor="admin-name">Name</label>
            <input
              id="admin-name"
              className={shell.field}
              value={name}
              onChange={(event) => setName(event.target.value)}
              placeholder="Frau Dr. Kern"
              required
            />
          </div>
          <div>
            <label htmlFor="admin-email">Dienstliche E-Mail-Adresse</label>
            <input
              id="admin-email"
              className={shell.field}
              type="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              placeholder="leitung@schule.de"
              required
            />
          </div>
        </div>

        <div className={styles.actions}>
          <button
            type="submit"
            className={shell.button}
            disabled={invite.isPending || email.trim() === "" || name.trim() === ""}
          >
            {invite.isPending ? "Wird eingeladen …" : "Einladung senden"}
          </button>
        </div>
      </form>
    </div>
  );
}
